// extracted by mini-css-extract-plugin
export var sliderRange = "_ni-2";
export var sliderRoot = "_ni-0";
export var sliderThumb = "_ni-3";
export var sliderTrack = "_ni-1";